<template>
  <div id="app">
    <section class="container">      
      
      <Header />
      <!-- <Video /> -->
      <Hero />
      <Bio />
    </section>
  </div>
</template>

<script>
import Header from './components/sections/Header'
// import Video from './components/sections/Video'
import Hero from './components/sections/Hero'
import Bio from './components/sections/Bio'


export default {
  name: 'App',
  components: {
    Hero,
    Header,
    // Video,
    Bio,   
  }
}
</script>
